import React from 'react'
import { useNavigate } from 'react-router-dom';
import { AUTHENTICATED_ROUTES } from '../../resources/routes-constants';
import ConfirmationForm from '../common/ConfirmationForm';

const PorfolioConfirmPopup: React.FC = () => {
    const navigate = useNavigate();

    const onClose = () => {
        navigate(AUTHENTICATED_ROUTES.PORTFOLIOS_ROUTE, {replace: true});
    }
    return <ConfirmationForm title='Confirmed!' content='Your portfolio has been saved as draft' onClose={onClose} confirmAction={[
        {title: "Done", type: "primary", action: onClose}
    ]} />
}

export default PorfolioConfirmPopup